var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Dots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.526 12.2259C12.0323 12.2259 12.4427 11.8155 12.4427 11.3092C12.4427 10.803 12.0323 10.3926 11.526 10.3926C11.0198 10.3926 10.6094 10.803 10.6094 11.3092C10.6094 11.8155 11.0198 12.2259 11.526 12.2259Z",
    stroke: "#475569",
    strokeWidth: 2.71857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.526 5.81185C12.0323 5.81185 12.4427 5.40144 12.4427 4.89518C12.4427 4.38892 12.0323 3.97852 11.526 3.97852C11.0198 3.97852 10.6094 4.38892 10.6094 4.89518C10.6094 5.40144 11.0198 5.81185 11.526 5.81185Z",
    stroke: "#475569",
    strokeWidth: 2.71857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.526 18.6439C12.0323 18.6439 12.4427 18.2335 12.4427 17.7272C12.4427 17.221 12.0323 16.8105 11.526 16.8105C11.0198 16.8105 10.6094 17.221 10.6094 17.7272C10.6094 18.2335 11.0198 18.6439 11.526 18.6439Z",
    stroke: "#475569",
    strokeWidth: 2.71857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dots);
export default __webpack_public_path__ + "static/media/3dots.94a77617bba535e8eafeb1db12e0f641.svg";
export { ForwardRef as ReactComponent };